module.exports = __webpack_public_path__ + "assets/img/1.0966b4b3.jpg";